export { default as AutomaticReportJobBase } from "./Base";
export * from "./Base";

export { default as AutomaticReportJobCompetitor } from "./Competitor";
export * from "./Competitor";

import AutomaticReportJobBase from "./Base";
import AutomaticReportJobCompetitor from "./Competitor";

export type AutomaticReportJob = AutomaticReportJobBase;

export function isCompetitorJob(
  automaticReportJob: AutomaticReportJob
): automaticReportJob is AutomaticReportJobCompetitor {
  return automaticReportJob.kind === "competitor";
}
